<style>
  div{
    font-family: "Microsoft Yahei";
  }
  ul,li{
    list-style: none !important;
    cursor: pointer;
  }
  .menuname:hover{
    text-decoration: underline;
  }
  .menuname.active{
    background-color:#0088CC;
    color:#ffffff;
  }
</style>

<template>
  <div id="menuTree">
    <li>
      <div style="font-size:16px;" >
        <i v-if='isFolder' class="fa " :class="[open?'fa-minus-square-o':'fa-plus-square-o']" @click='toggle()'></i>
        <input class="menuTree_1_check" type="checkbox" v-bind:data-id="model.id"/>
        <!--isFolder判断是否存在子级-->
        <i class="menuname">{{model.name}}</i>
      </div>
      <ul v-show="open" v-if='isFolder'>
        <items v-for="item in model.children" :model="item"></items>
      </ul>
    </li>
  </div>

</template>

<script>
  export default {
    name: 'items',
    props: ['model'],
    components: {},
    data() {
      return {
        open: true,
        isFolder: true,
      }
    },
    computed: {
      isFolder: function() {
        return this.model.childTreeNode && this.model.childTreeNode.length
      },
    },
    mounted(){
      $(".menuTree_1_check").click(function(){
        if($(this).hasClass("check")){
          $(this).removeClass("check");
        }else{
          $(this).addClass("check");
        }
        if(this.checked){
          $(this).parent().next("ul").find(".menuTree_1_check").prop("checked",true);
          $(this).parent().next("ul").find(".menuTree_1_check").addClass("check");
        }else{
          $(this).parent().next("ul").find(".menuTree_1_check").prop("checked",false);
          $(this).parent().next("ul").find(".menuTree_1_check").removeClass("check");
        }
      });
    },
    methods: {
      toggle: function() {
        if(this.isFolder) {
          this.open = !this.open
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// treejurisdiction.vue?1018806c